export default {
    namespaced: true,

    state: {
        name: process.env.MIX_APP_NAME,
        base_url: process.env.MIX_APP_URL,

        csrf_token: document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
        redirect_url: document.querySelector('meta[name="redirect-url"]').getAttribute("content"),

        drawer: true,
        miniVariant: localStorage.getItem('miniVariant') ? (/true/i).test(localStorage.getItem('miniVariant')) : false,
        filterDrawer: false,

        leftTopBar: [],
        rightTopBar: [],

        paginationRowsPerPage: [10, 20, 30],

        webpSupported: false,
    },

    getters: {
        getName(state) {
            return state.name;
        },
        getBaseUrl(state) {
            return state.base_url;
        },
        shouldRedirect(state) {
            return state.redirect_url !== null && state.redirect_url !== '';
        },
        getRedirectUrl(state) {
            return state.redirect_url;
        },
        getPerPage(state) {
            return state.paginationRowsPerPage;
        },
        getDrawerStatus(state) {
            return state.drawer;
        },
        getFilterDrawerStatus(state) {
            return state.filterDrawer;
        },
        getMiniVariantStatus(state) {
            return state.miniVariant;
        },
        getLeftTopBar(state) {
            return state.leftTopBar.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
        },
        getRightTopBar(state) {
            return state.rightTopBar.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
        },
        getWebpSupport(state) {
            return state.webpSupported;
        }
    },

    actions: {
        disableMainScroll() {
            const html = document.querySelector('html');
            html.setAttribute('data-overflow-hidden', '');
        },
        enableMainScroll() {
            const html = document.querySelector('html');
            html.removeAttribute('data-overflow-hidden');
        },
        getNewCSRFToken(context) {
            return new Promise((resolve, reject) => {
                window.axios.post('/token', {})
                    .then((response) => {
                        context.commit('setCSRFToken', response.data.token);
                        resolve();
                    });
            });
        },
        setRedirectUrl(context, path) {
            context.commit('setRedirectUrl', path);
        },
        changeDrawerStatus(context, status) {
            context.commit('setDrawerStatus', status);
        },
        changeMiniVariantStatus(context, status) {
            context.commit('setMiniVariantStatus', status);
        },
        changeFilterDrawerStatus(context, status) {
            context.commit('setFilterDrawerStatus', status);
        },

        addTopBarItem(context, data) {
            let position = 'leftTopBar';
            if (typeof data.position !== 'undefined' && data.position == 'right') {
                position = 'rightTopBar';
            }

            data.position = position;
            context.commit('addItemToTopBar', data);
        },
        updateTopBarItem(context, data) {
            let position = 'leftTopBar';
            if (typeof data.position !== 'undefined' && data.position == 'right') {
                position = 'rightTopBar';
            }

            data.position = position;
            context.commit('updateItemOnTopBar', data);
        },
        removeTopBarItem(context, data) {
            let position = 'leftTopBar';
            if (typeof data.position !== 'undefined' && data.position == 'right') {
                position = 'rightTopBar';
            }

            data.position = position;
            context.commit('removeItemFromTopBar', data);
        },
        resetTopBar(context) {
            context.commit('setTopBarToDefault')
        },

        checkWebpSupport(context) {
            return new Promise((resolve, reject) => {
                const image = new Image();

                image.onerror = (err) => {
                    context.commit('setWebpSupport', false);
                    resolve();
                };
                image.onload = () => {
                    window.axios.defaults.headers.common['Accept'] = 'application/json, text/plain, image/webp, */*';
                    context.commit('setWebpSupport', true);
                    resolve();
                };

                image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
            });
        },
    },

    mutations: {
        setCSRFToken(state, token) {
            state.csrf_token = token;

            window.axios.defaults.headers.common = {
                'X-CSRF-TOKEN': token,
                'X-Requested-With': 'XMLHttpRequest'
            };

            document.querySelector('meta[name="csrf-token"]').setAttribute("content", token);
        },
        setRedirectUrl(state, path) {
            state.redirect_url = path;
        },

        setFilterDrawerStatus(state, status) {
            state.filterDrawer = status;
        },
        setDrawerStatus(state, status) {
            state.drawer = status;
        },
        setMiniVariantStatus(state, status) {
            state.miniVariant = status;
            localStorage.setItem('miniVariant', status)
        },

        setTopBarToDefault(state) {
            state.leftTopBar = [];
            state.rightTopBar = [];
        },
        addItemToTopBar(state, data) {
            state[data.position].push(data.item);
        },
        updateItemOnTopBar(state, data) {
            if (typeof data.item.slug !== 'undefined') {
                let topBarItem = state[data.position].find((item) => {
                    return item.slug == data.item.slug;
                });

                if (typeof topBarItem !== 'undefined') {
                    topBarItem.text = data.item.text;
                } else {
                    this.commit("application/addItemToTopBar", data)
                }
            } else {
                console.error('Slug not defined!');
            }
        },
        removeItemFromTopBar(state, data) {
            if (typeof data.slug !== 'undefined') {
                let topBarItem = state[data.position].find((item) => {
                    return item.slug == data.slug;
                });

                if (typeof topBarItem !== 'undefined') {
                    const updatedTopBar = state[data.position].filter((obj) => {
                        return obj.slug !== data.slug;
                    });

                    state[data.position] = updatedTopBar;
                }
            } else {
                console.error('Slug not defined!');
            }
        },

        setWebpSupport(state, value) {
            state.webpSupported = value;
        }
    }
}
